/**
 * The teams that aren't part of the main script: travellers are added to and
 * removed from the game as it plays, while fabled and loric are storyteller
 * tools rather than playable characters.
 * @type {Array.<String>}
 */
export const SPECIAL_TEAMS = ["traveller", "fabled", "loric"];

/**
 * Checks whether the given team is one of {@link SPECIAL_TEAMS}.
 *
 * @param  {String} team
 *         Team to check.
 * @return {Boolean}
 *         true if the team is a special team, false otherwise.
 */
export function isSpecialTeam(team) {
    return SPECIAL_TEAMS.includes(team);
}
